/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Script_SettingsInputs */



/**
* | output |
* | --- |
* | "Script Settings" |
*
* @param {Script_SettingsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const script_settings = /** @type {((inputs?: Script_SettingsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Script_SettingsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Paramètres du script")
	if (locale === "de") return /** @type {LocalizedString} */ ("Skripteinstellungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impostazioni script")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Настройки скрипта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Configuración del script")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("脚本设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スクリプト設定")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्क्रिप्ट सेटिंग्स")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Configurações de script")
	return /** @type {LocalizedString} */ ("Script Settings")
});